import * as Ajax from "./types";
import { Container } from "../../state/types";
import { StatusCode } from "./statusCode";

class AjaxResponse implements Ajax.AjaxResponse
{
    public constructor(request: XMLHttpRequest)
    {
        this._status = <StatusCode>("" + request.status);
        this._response = request.response;
    }

    public get succeeded(): boolean
    {
        return StatusCode.IsSuccess(this._status);
    }

    public get status(): StatusCode
    {
        return this._status;
    }

    public get response(): string
    {
        return this._response;
    }

    public get location(): string
    {
        return this._location;
    }

    // self
    private _status: StatusCode;
    private _response: string;
    private _location: string;
}

let sendRequest: Ajax.sendRequestFunction = function (
    method: string, url: string, body: string,
    headers: Container = null): Promise<AjaxResponse>
{

    let request = new XMLHttpRequest();
    request.withCredentials = true;

    return new Promise((resolve, reject) =>
    {
        request.onreadystatechange = () =>
        {
            if (request.readyState !== 4) {
                return;
            }

            let response = new AjaxResponse(request);
            let success = response.succeeded;

            if (success) {
                resolve(response);

            } else {
                reject(response);

            }
        };

        request.open(method, url, true);

        if (headers !== null) {
            for (var header in headers) {
                request.setRequestHeader(header, headers[header]);
            }
        }

        request.send(body);
    });
}

export
{
    AjaxResponse,
    sendRequest as sendAjaxRequest
};